export enum Authorization {
  FULL = 'FULL',
  READ_ONLY = 'READ_ONLY',
  FORBID_DEVICE = 'FORBID_DEVICE',
  EXTERNAL_NUMBER = 'EXTERNAL_NUMBER',
}
